/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvalSuiteManifest,
  EvalSuiteManifest$inboundSchema,
  EvalSuiteManifest$Outbound,
  EvalSuiteManifest$outboundSchema,
} from "./evalsuitemanifest.js";

export type CreateEvalSuiteRequest = {
  name: string;
  description?: string | undefined;
  manifest: EvalSuiteManifest;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const CreateEvalSuiteRequest$inboundSchema: z.ZodType<
  CreateEvalSuiteRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  description: z.string().optional(),
  manifest: EvalSuiteManifest$inboundSchema,
  metadata: z.record(z.string()).optional(),
});
/** @internal */
export type CreateEvalSuiteRequest$Outbound = {
  name: string;
  description?: string | undefined;
  manifest: EvalSuiteManifest$Outbound;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const CreateEvalSuiteRequest$outboundSchema: z.ZodType<
  CreateEvalSuiteRequest$Outbound,
  z.ZodTypeDef,
  CreateEvalSuiteRequest
> = z.object({
  name: z.string(),
  description: z.string().optional(),
  manifest: EvalSuiteManifest$outboundSchema,
  metadata: z.record(z.string()).optional(),
});

export function createEvalSuiteRequestToJSON(
  createEvalSuiteRequest: CreateEvalSuiteRequest,
): string {
  return JSON.stringify(
    CreateEvalSuiteRequest$outboundSchema.parse(createEvalSuiteRequest),
  );
}
export function createEvalSuiteRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateEvalSuiteRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateEvalSuiteRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateEvalSuiteRequest' from JSON`,
  );
}
